import React from 'react';
import styled from 'styled-components';
import Button from '~/components/Button';
import Text from '~/components/Text';
import { Translation } from '~/components/Translation';
import Logo from '~/components/Logo';
import LinkBody from '~/components/LinkBody';
import { HEADER_HEIGHT } from '~/scenes/OnAir/constants';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	background-color: ${({ theme }) => theme.colors.background};
`;

const Header = styled.header`
	flex: 0;
	position: relative;
	border-bottom: 1px solid ${({ theme }) => theme.colors.line};
	padding-left: 16px;
`;

const HeaderInner = styled.div`
	width: 100%;
	height: ${HEADER_HEIGHT}px;
	display: flex;
	align-items: center;
`;

const LogoWrap = styled.div`
	display: flex;
	margin-right: auto;
`;

const IconLogo = styled(Logo)`
	height: 34px;
`;

const Content = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 32px;
	text-align: center;
	gap: 24px;
	max-width: 500px;
	margin: 0 auto;
`;

const SupportLink = styled.div`
	margin-top: 16px;
`;

interface Props {
	webinarId: string;
}

const OnAirErrorFallback: React.FC<Props> = ({ webinarId }) => {
	const handleReload = () => {
		window.location.reload();
	};

	const queryParams = new URLSearchParams({
		utm_source: 'streamyard',
		utm_campaign: 'webinar',
		utm_content: webinarId,
	});
	const supportUrl = `https://streamyard.com/contact?${queryParams.toString()}`;

	return (
		<Container>
			<Header role="banner">
				<HeaderInner>
					<LogoWrap>
						<IconLogo variant="icon" />
					</LogoWrap>
				</HeaderInner>
			</Header>
			<Content>
				<Text variant="h2">
					<Translation tid="common.onAir.error.title" />
				</Text>
				<Text variant="body">
					<Translation tid="common.onAir.error.description" />
				</Text>
				<Button onClick={handleReload} size="medium">
					<Translation tid="common.onAir.error.button.reload" />
				</Button>
				<SupportLink>
					<Text variant="body2" color="main">
						<LinkBody href={supportUrl} newTab>
							<Translation tid="broadcasts.onAir.supportChatButton.label" />
						</LinkBody>
					</Text>
				</SupportLink>
			</Content>
		</Container>
	);
};

export default OnAirErrorFallback;
